import { ScopeOption } from '../types';
import { usersScopes } from './users.scopes';
import { createAccountScopes } from './createAccount.scopes';
import { reportsScopes } from './reports.scopes';
import { documentsScopes } from './documents.scopes';
import { timesheetScopes } from './timesheet.scopes';
import { journalScopes } from './journal.scopes';
import { tablesScopes } from './tables.scopes';
import { homeScopes } from './home.scopes';
import { auditScopes } from './audit.scopes';
import { guideScopes } from './guide.scopes';
import { staffScopes } from './staff.scopes';

/**
 * Единая агрегированная карта скоупов всех системных разрешений
 */
export const PERMISSION_SCOPES_CONFIG: Record<string, ScopeOption[]> = {
  ...usersScopes,
  ...createAccountScopes,
  ...reportsScopes,
  ...documentsScopes,
  ...timesheetScopes,
  ...journalScopes,
  ...tablesScopes,
  ...homeScopes,
  ...auditScopes,
  ...guideScopes,
  ...staffScopes
};

// Реэкспорт индивидуальных скоупов по модулям
export {
  usersScopes,
  createAccountScopes,
  reportsScopes,
  documentsScopes,
  timesheetScopes,
  journalScopes,
  tablesScopes,
  homeScopes,
  auditScopes,
  guideScopes,
  staffScopes
};

